import sarahAvatar from "@/assets/testimonial-sarah.jpg";
import jamesAvatar from "@/assets/testimonial-james.jpg";
import { Star } from "lucide-react";

const TESTIMONIALS = [
  {
    name: "Sarah",
    city: "Amsterdam",
    avatar: sarahAvatar,
    quote: "Found the best smash burger in Amsterdam.",
  },
  {
    name: "James",
    city: "London",
    avatar: jamesAvatar,
    quote: "Way better than scrolling Google Maps.",
  },
];

export const LandingTestimonials = () => (
  <section className="mt-16 md:mt-20 mx-auto w-full max-w-3xl grid gap-4 sm:grid-cols-2">
    {TESTIMONIALS.map((t) => (
      <figure
        key={t.name}
        className="rounded-2xl border border-border/60 bg-card p-5 shadow-soft"
      >
        <div className="flex items-center gap-3">
          <img
            src={t.avatar}
            alt={`${t.name} from ${t.city}`}
            width={512}
            height={512}
            loading="lazy"
            decoding="async"
            className="h-11 w-11 rounded-full object-cover"
          />
          <figcaption className="text-sm font-semibold text-foreground">
            {t.name}, <span className="font-normal text-muted-foreground">{t.city}</span>
          </figcaption>
        </div>
        <div className="mt-3 flex items-center gap-0.5" aria-label="Rated 5 out of 5">
          {Array.from({ length: 5 }).map((_, i) => (
            <Star key={i} className="h-3.5 w-3.5 fill-primary text-primary" aria-hidden="true" />
          ))}
        </div>
        <blockquote className="mt-2 text-base text-foreground/80">"{t.quote}"</blockquote>
      </figure>
    ))}
  </section>
);

export default LandingTestimonials;
